/*
 * @Description: 
 * @Autor: Ray7hw
 * @LastEditTime: 2020-10-20 16:10:07
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
// import promise from 'es6-promise'
// promise.polyfill()
import Vue from 'vue'
import ElementUI, {
  Message
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './style/common.css'
import './style/element.scss'
import './style/common.css'
import './assets/font/iconfont.css'
// import 'babel-polyfill'

import App from './App'
import router from './router'
import axios from 'axios'
import BaiduMap from 'vue-baidu-map'
import store from './store'

import download from 'ly-downloader'
Vue.prototype.download = download

import Moment, {
  duration
} from 'moment'
Vue.prototype.moment = Moment

Vue.use(BaiduMap, {
  ak: '3fDnwzjirg3F5BwinEfL1z1xGbVZIbWl'
})


Vue.use(ElementUI);
// import {
//   Button,
//   Form,
//   Input,
//   // Message
// } from 'element-ui';
// Vue.use(Button)
// Vue.use(Form)
// Vue.use(Input)
// import {
//   Message
// } from 'element-ui'
Vue.prototype.$message = Message
// Vue.use(Message)





//axios.defaults.baseURL = 'http://localhost:8080/wjspay/'


// axios.defaults.baseURL = 'http://weisou.mynatapp.cc/wjspay/'
// axios.defaults.baseURL = 'http://hqw.mynatapp.cc/wjspay/'
axios.defaults.baseURL = 'https://pay.hbcpre.com/wjspay/'
//axios.defaults.baseURL = 'https://pay.hbcpre.com/wjspay/'
// axios.defaults.baseURL = 'http://hqw.mynatapp.cc/wjspay/'



// 引入axios
// import "./api/index.js"
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$url = 'https://pay.hbcpre.com/wjspay/'
// Vue.prototype.$url = 'http://hqw.mynatapp.cc/wjspay/'
// Vue.prototype.$url = 'http://weisou.mynatapp.cc/wjspay/'

//Vue.prototype.$url = 'http://localhost:8080/wjspay/'
 //Vue.prototype.$url = 'http://hqw.mynatapp.cc/wjspay/'
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // console.log(localStorage.getItem("token"), 88)
  // 在发送请求之前做些什么
  // 添加token的heaaers头
  let token = localStorage.getItem("token") || "";
  // console.log(token, 88)
  config.headers.token = token

  return config;
}, )

//拦截器---拿到结果
axios.interceptors.response.use(
  config => {
    if (config.data.code == -1 || !config.data.code) {
     // Message.error(config.data.msg);
    //  alert(config.data.msg)
      setTimeout(() => {
        router.push({
          path: '/login'
        })
      }, 0)
      return
    }

    config = config
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  components: {
    App
  },
  data: {
    evenhub: new Vue()
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js